// local imports
import { useCustomerAgreementsService, useQuery } from 'app/hooks/services';
import { CustomDataTable } from 'app/components/organisms/table';
import { CustomCard } from 'app/components/atoms';

const CustomerAgreements = ({ customerId }) => {
  const tableQueries = {
    skip: 0,
    limit: 25,
    orderBy: 'created_at',
    sortBy: 'desc',
    end_user_id: customerId
  };

  // service connection
  const { queries, handleFilterChange, handlePageChange, handleSort } = useQuery(tableQueries);
  const { service, handleRefresh } = useCustomerAgreementsService(queries);

  return (
    <>
      <div>
        <CustomCard icon="bx-file" title="Onaylanan Sözleşmeler" contentClassName="px-20">
          <CustomDataTable
            defaultSortId={queries?.orderBy}
            defaultDirection={queries?.sortBy}
            service={service}
            queries={queries}
            handlePageChange={handlePageChange}
            handleChange={handleFilterChange}
            handleSort={handleSort}
            handleRefreshTable={handleRefresh}
          />
        </CustomCard>
      </div>
    </>
  );
};

export default CustomerAgreements;
